export class Employee {
    employeeid:number;
    name:String;
    phone:number;
    ext:number;
    email:String;
}